module.exports = __webpack_public_path__ + "static/media/bugFixing.9062dc5c.svg";